import { PostDepositPaymentsData, GetParamsData, PostDepositDefaultDate } from '$Deposits/lib/LibCommonData'
import { SetDepositNextStep } from './DepositAction'
import { moneyReg } from '$Deposits/lib/Reg';
import moment from 'moment'
import {
    GetMethodsActive,
    GetMethodCodeActive,
    GetMethodsDetails,
    GetDepositBankActive,
    GetDepositMemberBanksActive,
    GetDepositPayments,
    GetDepositMoneyStatus,
    GetDepositOldBankSixNumberStatus,
    GetDepositCardNumber_CC,
    GetDepositCardPIN_CC,
    GetDepositTimeSelect,
    GetDepositDateSelect,
} from './DepositUpdate'

export const WindowOpen = (data) => {
    const { redirectUrl } = GetDepositPayments() || {}
    let testUrl = redirectUrl && redirectUrl.split(":") || ''
    if (testUrl[0] != "https" && testUrl[0] != "http") {
        var BetWayWindow = window.open(
            '',
            '_blank',
            'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=650, height=650'
        );
        BetWayWindow.document.write(redirectUrl);
        BetWayWindow.focus();
    } else {
        const Opencontent = window.open(redirectUrl);
        Opencontent.document.title = "betway";
        Opencontent.focus();
    }
}

//LB提交判断
export const LB_Submit = (data = {}) => {
    const { money, moneyErrMsg } = GetDepositMoneyStatus() || {}
    const { bankName } = GetDepositBankActive() || {}
    const { accountNumber } = GetDepositMemberBanksActive() || {}
    const { isAutoAssign = false } = GetMethodsDetails() && GetMethodsDetails()['setting'] || {}
    if (isAutoAssign) {
        if (accountNumber && money && !moneyErrMsg) {
            return true
        }
    } else {
        if (bankName && accountNumber && money && !moneyErrMsg) {
            return true
        }
    }
    return false;
}

//BQR提交判断
export const BQR_Submit = (data = {}) => {
    const { money, moneyErrMsg } = GetDepositMoneyStatus() || {}
    const { bankName } = GetDepositBankActive() || {}
    const { accountNumber } = GetDepositMemberBanksActive() || {}

    if (bankName && accountNumber && money && !moneyErrMsg) {
        return true
    }
    return false;
}
//LB旧账户存款
export const OldBank_Submit = (data = {}) => {
    const { money, moneyErrMsg } = GetDepositMoneyStatus() || {}
    const { accountNumber } = GetDepositMemberBanksActive() || {}
    const { numCode, codeErrMsg } = GetDepositOldBankSixNumberStatus() || {}
    const depositTimeSelect = GetDepositTimeSelect() || ''

    const isDepositTimeValid = depositTimeSelect && depositTimeSelect !== 'NOT_SET'

    if (accountNumber && numCode && !codeErrMsg && money && !moneyErrMsg && isDepositTimeValid && !!GetDepositDateSelect()) {
        return true
    }
    return false;
}
//EZP提交判断
export const EZP_Submit = (data = {}) => {
    const { code } = GetDepositBankActive() || {}
    const { money, moneyErrMsg } = GetDepositMoneyStatus() || {}
    if (money && !moneyErrMsg && code) {
        return true
    }
    return false;
}
//TMW提交判断
export const TMW_Submit = (data = {}) => {
    const { money, moneyErrMsg } = GetDepositMoneyStatus() || {}
    if (money && !moneyErrMsg) {
        return true
    }
    return false;
}
//CC卡提交判断
export const CC_Submit = (data = {}) => {
    const { money, moneyErrMsg } = GetDepositMoneyStatus() || {}
    const { number, numberErrMsg } = GetDepositCardNumber_CC() || {}
    const { PIN, PINErrMsg } = GetDepositCardPIN_CC() || {}
    if (number && !numberErrMsg && PIN && !PINErrMsg && money && !moneyErrMsg) {
        return true
    }
    return false;
}
//THBQR提交判断
export const THBQR_Submit = (data = {}) => {
    const { money, moneyErrMsg } = GetDepositMoneyStatus() || {}
    if (money && !moneyErrMsg) {
        return true
    }
    return false;
}

//BC提交判断
export const BC_Submit = (data = {}) => {
    const { money, moneyErrMsg } = GetDepositMoneyStatus() || {}
    const { code } = GetDepositBankActive() || {}
    if (code && money && !moneyErrMsg) {
        return true
    }
    return false;
}

//CTC
export const CTC_Submit = (data = {}) => {
    const methodCode = GetMethodCodeActive() || ''
    const { money, moneyErrMsg } = GetDepositMoneyStatus() || {}
    const { code } = GetDepositBankActive() || {}
    if(methodCode == 'CHANNEL') {
        if (code) {
            return true
        }
    }
    if (money && !moneyErrMsg) {
        return true
    }
    return false;
}


